<template>
  <dl class="description-list">
    <slot></slot>
  </dl>
</template>
